import {Component, Mixins} from "vue-property-decorator"
import validateFormMixin from "@/mixins/validateFormMixin"
import {FormStatus} from "@/components/lib/models"
import {Vue} from "vue/types/vue"

@Component
class formMixin extends Mixins(validateFormMixin) {
  DURATION = 300;

  protected result: string = '';
  protected resultTranslation: string = '';
  protected status: FormStatus = '';

  protected form: Object = formMixin.clearForm();

  protected static clearForm(): Object {
    return {}
  }

  get statusClass(): string {
    let status = this.status;
    return status ? ('txt-' + status) : '';
  }

  protected refs(): { [key: string]: Vue | Element | Vue[] | Element[] } {
    let nestedRefs = (this.$refs['fields'] as any)?.$refs || {};
    return {
      ...this.$refs,
      ...nestedRefs
    }
  }

  get resultToShow(): string | undefined {
    let status = this.status;
    if (status) {
      return this.result || this.$t(this.resultTranslation) as string;
    }
  }

  protected submitCondition(): boolean {
    return this.validateForm();
  }

  protected submit(): void {
    this.submitPromise()
      .then(() => {}).catch(() => {});
  }

  protected submitPromise(): Promise<void> {
    return new Promise<void>((resolve, reject) => {

      this.status = '';
      this.result = '';
      this.resultTranslation = '';

      if (this.submitCondition()) {
        this.actionPromise()
          .then(res => {
            this.submitOnSuccess(res);
            resolve();
          })
          .catch(reason => {
            this.submitOnError(reason);
            reject();
          });
      } else {
        reject();
      }
    });
  }

  protected submitOnSuccessAdditional(res?: any): void {
    this.form = formMixin.clearForm();
  }
  protected submitOnSuccessAdditionalAsync(res?: any): void {}

  protected actionPromise(): Promise<any> {
    return Promise.resolve();
  }

  protected submitOnSuccess(res?: any): void {
    this.submitOnSuccessAdditional(res);
    this.status = 'success';
    this.result = this.$t('form.result.success') as string;
    setTimeout(() => {
      this.submitOnSuccessAdditionalAsync(res);
      this.clearFields();
    }, this.DURATION);
  }

  protected submitOnError(reason: any) {
    this.status = 'danger';
    this.result = reason;
    this.resultTranslation = 'form.result.error';
  }

}

export default formMixin
